import React from 'react';

import useServerSideRendering from '../../hooks/useServerSideRendering';
import useWindowSize from '../../hooks/useWindowSize';
import HorizontalTimePoint from './HorizontalTimePoint';
import VerticalTimePoint from './VerticalTimePoint';
import { TIME_LINE_EVENTS } from './timeLineEvents';

export interface EventProp {
  month: string;
  year: string;
  articleTitle: string;
  logoPath: string;
  articleLink?: string;
}

const TimeLine = () => {
  const { width: windowWidth } = useWindowSize();
  const hydrated = useServerSideRendering();

  return (
    <div className="justify-center mx-auto flex ">
      <div className="w-full px-16">
        <>
          {hydrated &&
            (windowWidth < 1200
              ? TIME_LINE_EVENTS.map((events, index) => (
                  <>
                    <div
                      className="ml-80 sm:ml-[12rem] relative my-48"
                      key={events[0].articleTitle}
                    >
                      <div className="w-px h-[310px] sm:h[380px] bg-gray-300"></div>
                      <VerticalTimePoint events={events} />
                    </div>
                    {index < TIME_LINE_EVENTS.length - 1 ? (
                      <div className="sm:mx-64 border-0 border-b border-solid border-gray-200"></div>
                    ) : (
                      <div className="sm:mx-64 border-0 border-b-2 border-solid border-gray-300"></div>
                    )}
                  </>
                ))
              : TIME_LINE_EVENTS.map((events, index) => (
                  <div key={events[0].articleTitle}>
                    <div className="flex justify-center px-[12rem] mt-72">
                      <HorizontalTimePoint events={events} />
                    </div>
                    {index < TIME_LINE_EVENTS.length - 1 ? (
                      <div className="mx-[12rem] py-64 border-0 border-b border-solid border-gray-200"></div>
                    ) : (
                      <div className="mx-[12rem] py-64 border-0 border-b-2 border-solid border-gray-300"></div>
                    )}
                  </div>
                )))}
        </>
      </div>
    </div>
  );
};

export default TimeLine;
